import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { formatCurrency, formatPercent } from '../../lib/formatters';

export default function Term({
  available = true,
  index,
  merchant,
  parentSelectedTerm,
  setParentTerm,
  term,
}) {
  const [selectedTerm, setSelectedTerm] = useState({term: null, payment: null});

  useEffect(() => {
    if (setParentTerm) setParentTerm(selectedTerm);
  }, [selectedTerm]);

  const termOnClick = (e) => {
    setSelectedTerm({
      term: parseInt(e.currentTarget.dataset.term),
      payment: parseFloat(e.currentTarget.dataset.payment.replace(/[^[0-9\.]/g,''))
    });
  };

  if (available) {
    return <div
      className={classNames("mb-4 term-container", {
        'term-available': setParentTerm,
        'selected': parentSelectedTerm && term.get('term') === parentSelectedTerm.term
      })}
      key={term.get('term')}
      id={"term-" + term.get('term')}
      data-term={term.get('term')}
      data-payment={formatCurrency(term.get('monthly_payment'))}
      onClick={termOnClick}
    >

      <div className="has-text-centered py-3">
        <div className="has-text-weight-bold">
          {term.get('term')} {term.get('term') === 1 ? 'single' : 'monthly'} payment{term.get('term') > 1 && 's'} of <span className="text-green-highlight">{formatCurrency(term.get('monthly_payment'))}</span>
        </div>
        <div className="has-text-grey">
          {formatCurrency(term.get('total_fees'))} total interest &#x2022; {term.get('term') > 1 ? 'First payment' : 'Payment'} 31 days after shipment
        </div>
      </div>
    </div>
  }

  if (!available) {
    return (<div
        className="mb-4 term-container term-unavailable"
        key={term.get('id')}
        id={"term-" + term.get('id')}
        data-term={term.get('term')}
        data-payment={formatCurrency(term.get('monthly_payment'))}
      >
      <div className="columns is-mobile">
        <div className="column is-one-half is-size-5">
          <p><strong>{term.get('term')} {term.get('term') === 1 ? 'month' : 'months'}</strong></p>
        </div>
        <div className="column is-one-half has-text-right">
          <p className="has-text-danger has-text-weight-bold">
            <span>Unavailable</span> <span className="icon" data-tooltip title="This option exceeds your payback capacity">
            <FontAwesomeIcon icon={['fal', 'info-circle']} /></span>
          </p>
        </div>
      </div>
    </div>);
  }
}
